// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ghost-item {
  width: 210px;
  float: left;
  margin-right: 10px;
  height: 50px;
}

.search-info {
  font-size: 14px;
  font-weight: 600;
}

.price {
  font-weight: 500;
}

.imgcell {
  text-align: center;
  background-color: #f4f4f4;
  vertical-align: middle;
  border-radius: 3px;
  width: 50px;
  height: 40px;
  background-image: url("/assets/images/svg/image.svg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}
.imgcell .img {
  height: 40px;
  width: 50px;
  display: inline-block;
  vertical-align: middle;
  background-size: contain;
  border-radius: 3px;
  background-repeat: no-repeat;
  background-position: center center;
}

mdb-card-header {
  font-weight: 500;
}

.recent-vehicles {
  font-size: 0.8rem;
}

.vehicle-info {
  height: 50px;
  padding-left: 5px;
  vertical-align: middle;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vehicle-info .line1 {
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--colour1);
}
.vehicle-info .line2 {
  font-size: 0.6rem;
  line-height: 0.9rem;
}
.vehicle-info .line3 {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/main/dashboard/widgets/widget-adverts-list/widget-adverts-list.scss"],"names":[],"mappings":"AAIA;EAEE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AAJF;;AAYA;EACE,eAAA;EACA,gBAAA;AATF;;AAaA;EAEE,gBAAA;AAXF;;AAeA;EAEE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EAAa,YAAA;EACb,qDAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AAZF;AAcE;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kCAAA;AAZJ;;AAgBA;EACE,gBAAA;AAbF;;AAgBA;EACE,iBAAA;AAbF;;AAgBA;EAEE,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAdF;AAgBE;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AAdJ;AAiBE;EACE,iBAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAhBJ","sourcesContent":[".search-buttons button {\n\n}\n\n.ghost-item {\n\n  width: 210px;\n  float: left;\n  margin-right: 10px;\n  height: 50px;\n\n}\n\n.recently-viewed-item {\n\n}\n\n.search-info {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n\n.price {\n\n  font-weight: 500;\n\n}\n\n.imgcell {\n\n  text-align: center;\n  background-color: #f4f4f4;\n  vertical-align: middle;\n  border-radius: 3px;\n  width: 50px; height: 40px;\n  background-image: url('/assets/images/svg/image.svg');\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: contain;\n\n  .img {\n    height: 40px;\n    width: 50px;\n    display: inline-block;\n    vertical-align: middle;\n    background-size: contain;\n    border-radius: 3px;\n    background-repeat: no-repeat;\n    background-position: center center;\n  }\n}\n\nmdb-card-header {\n  font-weight: 500;\n}\n\n.recent-vehicles {\n  font-size: 0.8rem;\n}\n\n.vehicle-info {\n\n  height: 50px;\n  padding-left: 5px;\n  vertical-align: middle;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  .line1 {\n    font-weight: 500;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    color: var(--colour1);\n  }\n\n  .line2 {\n    font-size: 0.6rem;\n    line-height: 0.9rem;\n  }\n\n  .line3 {\n    font-size: 0.75rem;\n    line-height: 1rem;\n    font-weight: 400;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
